<template>
  <ul class="nav-bar" :class="{ hide: activePage !== 'HomeMain' }">
    <li
      @click="handleClickBtn(link.target)"
      :class="`btn-${link.target} ${curNav === link.target ? 'active' : ''}`"
      v-for="link in navs"
      :key="link.title"
    >
      <a href="javascript:void(0);">{{ link.title }}</a>
    </li>
    <li @click.prevent="handleClickBtn(0)">
      <a href="javasctipt:void(0);">返回顶部</a>
    </li>
  </ul>
</template>

<script>
import * as utils from '@/pages/memes2020/index/utils'
export default {
  data() {
    return {
      curNav: 'writter',
      navs: [
        {
          title: '我要创作',
          target: 'writter',
        },
        {
          title: '排行榜',
          target: 'ranking',
        },
        {
          title: '奖品展示',
          target: 'prize',
        },
        {
          title: '查看故事会',
          target: 'catStory',
        },
      ],
    }
  },
  computed: {
    oContent() {
      return this.navs.map(item => document.getElementById(item.target))
    },
    activePage() {
      return this.$store.state.activePage
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    handleClickBtn(target) {
      utils.scrollTo(target)
    },
    handleScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const curContent = Array.prototype.slice
        .call(this.oContent)
        .filter(item => utils.getPos(item).top - scrollTop <= 120)
        .slice(-1)[0]
      if (curContent) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.curNav = curContent.id
        }, 20)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.nav-bar {
  position: fixed;
  top: 50%;
  right: 20px;
  width: 160px;
  height: 369px;
  margin-top: -184.5px;
  background-image: url('../assets/navbar-bg.png');
  z-index: 99;
  &.hide {
    display: none;
  }
  li {
    text-align: center;
    font-size: 0;
    cursor: pointer;
    a {
      display: inline-block;
      background: url('../assets/nav-item-new.png') no-repeat;
      font-size: 0;
    }

    &:not(:last-child) {
      &:hover,
      &.active {
        a {
          background-position-x: 0;
        }
      }
    }
    &:nth-child(1) {
      height: 66px;
      margin-top: 12px;
      padding-top: 24px;
      a {
        width: 85px;
        height: 19px;
        background-position-x: -130px;
      }
    }
    &:nth-child(2) {
      height: 75px;
      padding-top: 31px;
      a {
        width: 64px;
        height: 19px;
        background-position: -140px -74px;
      }
    }
    &:nth-child(3) {
      height: 75px;
      padding-top: 31px;
      a {
        width: 84px;
        height: 19px;
        background-position: -130px -148px;
      }
    }
    &:nth-child(4) {
      height: 75px;
      padding-top: 31px;
      a {
        width: 105px;
        height: 19px;
        background-position: -120px -222px;
      }
    }
    &:nth-child(5) {
      height: 75px;
      padding-top: 26px;
      a {
        width: 72px;
        height: 13px;
        background-position: -137px 100%;
      }
    }
  }
}
</style>
